import { COMPETITORS, COMPETITION_EVENTS } from '../../data/competitors';

/**
 * Build a competition event payload (or null) at the daily tick. The caller
 * is responsible for dispatching it via `triggerCompetitionEvent`.
 *
 * The roll is gated by working day + game age (> 15 days) + 4% chance.
 */
export function rollCompetitionEvent({ state, driversAfterLease, dayRevenue, working }) {
  if (!working) return null;
  if (state.pendingCompetitionEvent) return null;
  if (state.totalDays <= 15) return null;
  if (Math.random() >= 0.04) return null;

  const eligible = COMPETITION_EVENTS.filter(e => state.totalDays >= e.minDays);
  if (eligible.length === 0) return null;

  const evt = eligible[Math.floor(Math.random() * eligible.length)];
  const comp = COMPETITORS[Math.floor(Math.random() * COMPETITORS.length)];

  if (evt.type === 'contract_bid') {
    // 01/06/2026 — Legacy event kept only as a no-op so any old save with
    // a `pendingCompetitionEvent` of this type doesn't crash. The real AO
    // funnel lives in tenderSlice.js.
    return null;
  }
  if (evt.type === 'driver_poach') {
    const targetDriver = driversAfterLease.find(d => d.satisfaction < 55);
    if (!targetDriver) return null;
    return {
      title: `Débauchage — ${comp.name}`,
      competitorName: comp.name,
      description: `${comp.name} tente de recruter ${targetDriver.name} (satisfaction : ${Math.round(targetDriver.satisfaction)}%). Que faites-vous ?`,
      choices: [
        { label: `Augmenter le salaire (+15%)`, description: 'Votre chauffeur reste mais coûte plus cher.', cost: Math.round(targetDriver.employerCost * 0.15), reputationChange: 0 },
        { label: 'Ne rien faire', description: `Risque : ${targetDriver.name} pourrait partir.`, cost: 0, reputationChange: -1 },
        { label: 'Améliorer les conditions', description: 'Investir dans le bien-être général.', cost: 500, reputationChange: 3, recommended: true },
      ],
    };
  }
  if (evt.type === 'alliance_offer') {
    return {
      title: `Alliance proposée — ${comp.name}`,
      competitorName: comp.name,
      description: `${comp.name} propose de sous-traiter une partie de ses livraisons pendant 15 jours.`,
      choices: [
        { label: 'Accepter la sous-traitance', description: 'Revenus supplémentaires pendant 15 jours.', cost: 0, reputationChange: 2, recommended: true },
        { label: 'Refuser', description: 'Vous ne travaillez pas avec la concurrence.', cost: 0, reputationChange: 0 },
      ],
    };
  }
  if (evt.type === 'price_war') {
    return {
      title: `Guerre des prix — ${comp.name}`,
      competitorName: comp.name,
      description: `${comp.name} casse ses prix de 20% sur le marché ${comp.specialties[0]}. Vos clients hésitent.`,
      choices: [
        { label: 'Aligner vos prix', description: 'Gardez vos clients mais réduisez vos marges.', cost: Math.round(dayRevenue * 0.2), reputationChange: 0 },
        { label: 'Miser sur la qualité', description: 'Maintenez vos prix. Les clients fidèles resteront.', cost: 0, reputationChange: 3, recommended: true },
        { label: 'Contre-attaquer avec une promo', description: 'Offre spéciale -30% pendant 5 jours.', cost: Math.round(dayRevenue * 0.4), reputationChange: 1 },
      ],
    };
  }
  return null;
}
